if (!customElements.get('jmt-product-gallery')) {
  customElements.define('jmt-product-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.slides = [...this.querySelectorAll('[data-gallery-slide]')];
      this.buttons = [...this.querySelectorAll('[data-gallery-index]')];
      this.dialog = this.querySelector('dialog');
      this.index = 0;
      this.querySelector('.jmt-pdp-gallery-nav').hidden = false;
      this.querySelector('[data-gallery-zoom]').hidden = false;
      this.select(0);
      const stage = this.querySelector('.jmt-pdp-gallery-stage');
      stage.addEventListener('touchstart', event => {
        if (event.touches.length !== 1) return;
        this.touchStart = { x:event.touches[0].clientX, y:event.touches[0].clientY };
      }, { passive:true });
      stage.addEventListener('touchend', event => {
        if (!this.touchStart || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - this.touchStart.x;
        const dy = event.changedTouches[0].clientY - this.touchStart.y;
        if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          this.select((this.index + (dx < 0 ? 1 : -1) + this.slides.length) % this.slides.length);
        }
        this.touchStart = null;
      }, { passive:true });
      stage.addEventListener('touchcancel', () => { this.touchStart = null; }, { passive:true });
      this.addEventListener('click', event => {
        const choice = event.target.closest('[data-gallery-index]');
        if (choice) this.select(Number(choice.dataset.galleryIndex));
        if (event.target.closest('[data-gallery-zoom]')) {
          const source = this.slides[this.index].querySelector('img');
          const enlarged = this.dialog.querySelector('img');
          enlarged.src = source.src;
          enlarged.srcset = source.srcset;
          enlarged.sizes = '90vw';
          enlarged.alt = source.alt;
          this.dialog.showModal();
        }
        if (event.target.closest('[data-gallery-close]') || event.target === this.dialog) this.dialog.close();
      });
      this.querySelector('.jmt-pdp-thumbnails').addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : (this.index + (event.key === 'ArrowRight' ? 1 : -1) + this.slides.length) % this.slides.length;
        this.select(next);
        this.buttons[next].focus();
      });
    }
    select(index) {
      this.index = index;
      this.slides.forEach((slide, i) => { slide.hidden = i !== index; });
      this.buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
    }
  });
}

// A mobile shortcut to the same native form, never a second cart implementation.
if (!customElements.get('jmt-product-buybar')) {
  customElements.define('jmt-product-buybar', class extends HTMLElement {
    connectedCallback() {
      this.productInfo = this.closest('product-info');
      this.nativeButton = this.productInfo.querySelector('product-form button[name="add"]');
      this.nativeForm = this.nativeButton?.form;
      if (!this.nativeForm) return;
      this.button = this.querySelector('[data-buybar-submit]');
      this.onClick = () => {
        if (this.nativeButton.disabled || this.nativeButton.getAttribute('aria-disabled') === 'true') return;
        this.nativeForm.requestSubmit(this.nativeButton);
      };
      this.button.addEventListener('click', this.onClick);
      this.updatePosition = () => {
        this.hidden = this.nativeButton.getBoundingClientRect().bottom >= 0;
        const previewBar = document.getElementById('PBarNextFrameWrapper');
        const inset = previewBar?.getClientRects().length ? previewBar.getBoundingClientRect().height : 0;
        this.style.bottom = inset ? `${inset}px` : '';
      };
      this.sync = () => {
        this.updatePosition();
        this.button.disabled = this.nativeButton.disabled || this.nativeButton.getAttribute('aria-disabled') === 'true';
        this.button.textContent = this.nativeButton.classList.contains('loading') ? 'Adding…' : this.nativeButton.textContent.trim();
        const price = this.productInfo.querySelector('.price:not(.price--on-sale) .price__regular .price-item, .price--on-sale .price__sale .price-item--sale');
        this.querySelector('[data-buybar-price]').textContent = price?.textContent.trim() || '';
        const choice = [...this.productInfo.querySelectorAll('variant-selects input:checked')].map(input => input.value).join(' / ');
        this.querySelector('[data-buybar-choice]').textContent = choice;
        const error = this.productInfo.querySelector('.product-form__error-message')?.textContent.trim() || '';
        this.querySelector('[data-buybar-error]').textContent = error;
      };
      this.visibility = new IntersectionObserver(this.sync);
      this.visibility.observe(this.nativeButton);
      // A fast scroll / anchor jump can move the CTA from below to above the
      // viewport without changing its intersection state. Handle that too.
      this.onScroll = () => {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = 0;
          this.updatePosition();
        });
      };
      window.addEventListener('scroll', this.onScroll, { passive:true });
      window.addEventListener('resize', this.onScroll, { passive:true });
      this.observer = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target))) this.sync();
      });
      this.observer.observe(this.productInfo, { childList:true, subtree:true, attributes:true, attributeFilter:['disabled', 'aria-disabled', 'class'] });
      this.sync();
    }
    disconnectedCallback() {
      this.visibility?.disconnect();
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      cancelAnimationFrame(this.scrollFrame);
      this.observer?.disconnect();
      this.button?.removeEventListener('click', this.onClick);
    }
  });
}
